import { saveAs } from "file-saver"
import { url } from "../../../../../constants/url"
import isecurionlogo from '../../../../../Assests/ReportImages/isecurion1.png'
import { AlignmentType, BorderStyle, convertInchesToTwip, Footer, ImageRun, Header, LevelFormat, NumberFormat, Packer, PageBorderDisplay, PageBorderOffsetFrom, PageBorderZOrder, PageNumber, PageOrientation, Paragraph, SectionType, ShadingType, Table, TableCell, TableLayoutType, TableOfContents, TableRow, TabStopPosition, TextRun, VerticalAlign, WidthType, TabStopType, HeadingLevel } from "docx"
import { toast } from "react-toastify"
import { fontPageBlueImage, isecurionLogo1, reportDate, reportTestingName, } from "./Part1/FrontPage-Support"
import { Document } from "docx"
import { confidentialMaterial1, confidentialMaterial2, confidentialMaterial3, confidentialMaterial4 } from "./Part1/Page1-Support"
import { documentFirstTable, documentHeading2, documentSecondTable, documnetHeading } from "./Part1/Page2-Support"
import { page3firstTable, page3Heading, page3Heading2, page3Heading3, page3SecondTable, page3Text, page3ThirdTable } from "./Part1/Page3-Support"
import { TOCHeadings } from "../../Web/BlueFormat/Part1/Page4/TableOfContent"
import { bulletFour, bulletOne, bulletThree, bulletTwo, objectiveHeading, objectiveImage, objectiveSecondImage, objectiveText } from "./Part1/Page5-Support"
import { scopeHeading, scopeImage, scopeTable, scopeText } from "./Part1/Page6-Support"
import { imageThree, recommendsBulletOne, recommendsBulletTwo, recommendsText, secondbulleThree, secondbulletOne, secondbulletwo, secondReviewHeading, SecurityBulletOne, SecurityBulleTwo, SecurityHeading, summaryHeading, summaryImage, summaryText } from "./Part1/Page7-Support"
import { imageFour, methodologyHeading, methodologyText, setUpAndMethodology } from "./Part2/Page8-Support"
import { applicationBulletFive, applicationBulletFour, applicationBulletOne, applicationBulletSix, applicationBulletThree, applicationBulletTwo, ApplicationThreatModellingHeading, ApplicationThreatModellingText, InformationBulletFive, InformationBulletFour, InformationBulletOne, InformationBulletThree, InformationBulletTwo, InformationGatheringHeading, InformationGatheringText, overviewText } from "./Part2/Page9-Support"
import { sourceCodeBulletEight, sourceCodeBulletEleven, sourceCodeBulletFive, sourceCodeBulletFour, sourceCodeBulletFourteen, sourceCodeBulletNine, sourceCodeBulletOne, sourceCodeBulletSeven, sourceCodeBulletSix, sourceCodeBulletTen, sourceCodeBulletThirtteen, sourceCodeBulletThree, sourceCodeBulletTwelve, sourceCodeBulletTwo, sourceCodeHeading, sourceCodeTextOne, sourceCodeTextThree, sourceCodeTextTwo } from "./Part2/Page10-Support"
import { methodology4_1, methodology4_2, methodology4_3, methodology4_4, methodology4_5 } from "./Headings/Headings"
import { auditTools, frameWorkTable, OwaspBullet, OwaspBulletTwo, strongPoint1, toolsTable, weakPoint1 } from "./Part2/Page11-Support"
import { observartionSummaryText, vulnerabilityTable } from "./Part2/Page12-Support"
import { chartDescription, severityLevelTable, severityRiskRating, tableDescription } from "./Part2/Page13-Support"
import { findingsHeading, findingsText, findingsText2, imagefive } from "./Part2/Page15-Support"
import { lastPage } from "../../Web/BlueFormat/Part3/ReportEnd.js"

export async function SourceCodeSkeleton(props) {
    const { date, customerName, author, clientName, consultantName, applicationName, applicationURL, testStartDate,
        testEndDate, environmentType, emailVer, logout, userRoles, critical, high, medium, low, info, vulCount, brokenAccess,
        cryptoFailures, injection, inseureDesign, security, outdatedComp, identification, softwareFailures,
        securityFailures, ssrf, generatedReportData, pocDetails, loading, setLoading, textAreaValue, testingType,
        weakPoints, strongPoints, image, imageUrl, appDiscription, cricatility
    } = props

    console.log(generatedReportData)

    const reportName = `${applicationName} Source Code Security Audit Report`

    const frontPage1 = fontPageBlueImage
    const frontPage2 = isecurionLogo1
    const frontPage3 = reportDate(date)
    const frontPage4 = reportTestingName(reportName)
    //   page 1 detail
    const page11 = confidentialMaterial1
    const page12 = confidentialMaterial2
    const page13 = confidentialMaterial3(customerName)
    const page14 = confidentialMaterial4(customerName)
    //  page 2 details
    const page21 = documnetHeading
    const page22 = documentFirstTable(applicationName)
    const page23 = documentHeading2
    const page24 = documentSecondTable(author, date, customerName)

    // page 3 details
    const page31 = page3Heading
    const page32 = page3Text
    const page33 = page3firstTable(date)
    const page34 = page3Heading2
    const page35 = page3SecondTable(clientName, customerName) /* this is doubt */
    const page36 = page3Heading3
    const page37 = page3ThirdTable(consultantName)

    // page 4 details
    const page41 = TOCHeadings
    // page 5 details
    const page51 = objectiveImage
    const page52 = objectiveHeading
    const page53 = objectiveText(customerName)
    const page54 = objectiveSecondImage
    const page55 = bulletOne
    const page56 = bulletTwo
    const page57 = bulletThree
    const page58 = bulletFour

    // page 6 details
    const page61 = scopeImage
    const page62 = scopeHeading
    const page63 = scopeText(customerName)
    const page64 = scopeTable

    // page 7 details
    const page71 = imageThree
    const page72 = summaryHeading
    const page73 = summaryText(customerName, testStartDate, testEndDate)
    const page74 = summaryImage
    const page75 = SecurityHeading
    const page76 = SecurityBulletOne
    const page77 = SecurityBulleTwo
    const page78 = secondReviewHeading
    const page79 = secondbulletOne
    const page80 = secondbulletwo
    const page711 = secondbulleThree
    const page712 = recommendsText
    const page713 = recommendsBulletOne
    const page714 = recommendsBulletTwo

    // page 8 details
    const page81 = imageFour
    const page82 = methodologyHeading
    const page83 = methodologyText
    const page84 = setUpAndMethodology

    // page 9 details
    const page91 = InformationGatheringHeading
    const page92 = InformationGatheringText
    const page93 = InformationBulletOne
    const page94 = InformationBulletTwo
    const page95 = InformationBulletThree
    const page96 = InformationBulletFour
    const page97 = InformationBulletFive
    const page98 = ApplicationThreatModellingHeading
    const page99 = ApplicationThreatModellingText
    const page100 = overviewText
    const page911 = applicationBulletOne
    const page912 = applicationBulletTwo
    const page913 = applicationBulletThree
    const page914 = applicationBulletFour
    const page915 = applicationBulletFive
    const page916 = applicationBulletSix

    // page 10 details
    const page101 = sourceCodeHeading
    const page102 = sourceCodeTextOne
    const page103 = sourceCodeTextTwo
    const page104 = sourceCodeTextThree
    const page105 = sourceCodeBulletOne
    const page106 = sourceCodeBulletTwo
    const page107 = sourceCodeBulletThree
    const page108 = sourceCodeBulletFour
    const page109 = sourceCodeBulletFive
    const page110 = sourceCodeBulletSix
    const page1011 = sourceCodeBulletSeven
    const page1012 = sourceCodeBulletEight
    const page1013 = sourceCodeBulletNine
    const page1014 = sourceCodeBulletTen
    const page1015 = sourceCodeBulletEleven
    const page1016 = sourceCodeBulletTwelve
    const page1017 = sourceCodeBulletThirtteen

    // page 11 details
    const page111 = methodology4_1
    const page112 = OwaspBullet
    const page113 = toolsTable
    const page114 = OwaspBulletTwo
    const page115 = auditTools
    const page116 = methodology4_2
    const page117 = weakPoint1(weakPoints)
    const page118 = methodology4_3
    const page119 = strongPoint1(strongPoints)

    // page 12 details
    const page121 = methodology4_4
    const page122 = observartionSummaryText(vulCount)
    const page123 = vulnerabilityTable

    // page 13 details
    const page131 = severityRiskRating
    const page132 = severityLevelTable(high, medium, low)
    const page133 = tableDescription
    const page134 = chartDescription

    // page 14 Details
    const page141 = methodology4_5

    // page 15 details
    const page151 = imagefive
    const page152 = findingsHeading
    const page153 = findingsText
    const page154 = findingsText2

    // last  page 
    const page161 = lastPage



    const design = {
        page: {
            margin: { top: 800, right: 500, bottom: 800, left: 500, header: 500, footer: 500 },
            size: { width: 12240, height: 15840, orientation: PageOrientation.PORTRAIT },
            borders: {
                pageBorderBottom: { style: BorderStyle.DASH_SMALL_GAP, size: 1 * 8, color: "1e8ff9" },
                pageBorderLeft: { style: BorderStyle.DASH_SMALL_GAP, size: 1 * 8, color: "1e8ff9" },
                pageBorderRight: { style: BorderStyle.DASH_SMALL_GAP, size: 1 * 8, color: "1e8ff9" },
                pageBorderTop: { style: BorderStyle.DASH_SMALL_GAP, size: 1 * 8, color: "1e8ff9" },
                pageBorders: {
                    display: PageBorderDisplay.ALL_PAGES,
                    offsetFrom: PageBorderOffsetFrom.TEXT,
                    zOrder: PageBorderZOrder.FRONT,
                },
            },
            type: SectionType.CONTINUOUS,
        },
    }

    const rows = [
        new TableRow({
            children: [
                new TableCell({
                    width: { size: 5, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 200, after: 200 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "#",
                                    font: "Calibri",
                                    size: 22,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })
                    ],
                    shading: { type: ShadingType.SOLID, color: "1F497D" },
                    indent: { left: 600 },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                    }
                }),
                new TableCell({
                    width: { size: 28, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 200, after: 200 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Observed Vulnerability",
                                    font: "Calibri",
                                    size: 22,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })
                    ],
                    shading: { type: ShadingType.SOLID, color: "1F497D" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                    }
                }),
                new TableCell({
                    width: { size: 14, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 200, after: 200 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Risk Rating",
                                    font: "Calibri",
                                    size: 22,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })
                    ],
                    shading: { type: ShadingType.SOLID, color: "1F497D" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                    }
                }),
                new TableCell({
                    width: { size: 53, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 200, after: 200 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Recommendation",
                                    font: "Calibri",
                                    size: 22,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })
                    ],
                    shading: { type: ShadingType.SOLID, color: "1F497D" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                    }
                })
            ],
        }),
    ];

    const severityRank = {
        "Critical": 5,
        "High": 4,
        "Medium": 3,
        "Low": 2,
        "Information": 1
    };

    const sortedVulnerabilities = [...generatedReportData].sort(
        (a, b) => severityRank[b.severity] - severityRank[a.severity]
    );
    sortedVulnerabilities.forEach((vulnerability, index) => {
        function getSeverityAndColor(severity) {
            let color = "";
            if (severity = "Critical") {
                color = "c00000";
            } else if (severity = "High") {
                color = "ff0000";
            } else if (severity = "Medium") {
                color = "ffc000";
            } else if (severity = "Low") {
                color = "ffff00";
            } else {
                severity = "Information";
                color = "00b050";
            }
            return { severity, color };
        }

        const severity = vulnerability.severity;
        const { color } = getSeverityAndColor(severity);
        rows.push(
            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 5, type: WidthType.PERCENTAGE },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: `${index + 1}.`,
                                        font: "Calibri",
                                        size: 22,
                                        color: "0f0f3f",
                                        italics: false
                                    })
                                ]
                            })
                        ],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        indent: { left: 600 },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        }
                    }),
                    new TableCell({
                        width: { size: 28, type: WidthType.PERCENTAGE },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                indent: { left: 60 },
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.LEFT,
                                children: [
                                    new TextRun({
                                        text: vulnerability.vulnerabilityName,
                                        font: "Calibri",
                                        size: 22,
                                        color: "0f0f3f",
                                        italics: false
                                    })
                                ]
                            })
                        ],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        }
                    }),
                    new TableCell({
                        width: { size: 14, type: WidthType.PERCENTAGE },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: severity,
                                        font: "Calibri",
                                        size: 22,
                                        color: "0f0f3f",
                                        italics: false
                                    })
                                ]
                            })
                        ],
                        shading: {
                            type: ShadingType.SOLID,
                            color: severity === "Critical" ? "c00000" : severity === "High" ? "ff0000" : severity === "Medium" ? "ffc000" : severity === "Low" ? "ffff00" : severity === "Information" ? "00b050" : "ffffff"
                        },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        }
                    }),

                    new TableCell({
                        width: { size: 53, type: WidthType.PERCENTAGE },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            ...vulnerability.recommendation.split(/•\s*/).filter(Boolean).map(bulletText =>
                                new Paragraph({
                                    indent: { left: 600 },
                                    spacing: { before: 50, after: 50 },
                                    alignment: AlignmentType.LEFT,
                                    bullet: { level: 0 },
                                    children: [
                                        new TextRun({
                                            text: bulletText.trim(),
                                            font: "Calibri",
                                            size: 22,
                                            color: "0f0f3f",
                                            italics: false
                                        })
                                    ]
                                })
                            )

                        ],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        }
                    })

                ],
            })
        );
    });
    const MAX_WIDTH = 670;

    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const getImageDimensions = (dataUrl) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                const aspectRatio = img.width / img.height;
                const width = Math.min(img.width, MAX_WIDTH);
                const height = width / aspectRatio;
                resolve({ width, height });
            };
            img.onerror = (error) => reject(error);
            img.src = dataUrl;
        });
    };

    const createImageRun = async (file) => {
        try {
            const imageData = await getBase64(file);
            const dimensions = await getImageDimensions(imageData);
            return new ImageRun({
                data: imageData,
                transformation: { width: dimensions.width, height: dimensions.height },
            });
        } catch (error) {
            console.error('Error reading image data:', error);
            return null;
        }
    };

    const fetchImageAsBase64 = async (url) => {
        const response = await fetch(url, { mode: 'cors' });
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }


    const sortVulnerabilities = [...generatedReportData].sort(
        (a, b) => severityRank[b.severity] - severityRank[a.severity]
    );
    const docSections = sortVulnerabilities.map(async (vulnerability, index) => {
        const combinedContent = [];

        for (let i = 0; i < (vulnerability.poc || []).length; i++) {
            const pocText = vulnerability.poc[i]?.poc || "";
            const matchingPocDetails = pocDetails.find(
                (p) => p.data.vulId === vulnerability._id
            );
            const match = pocText.match(/^(Scenario\s*[123])\s*(.*)$/);
            if (match) {
                combinedContent.push(
                    new Paragraph({
                        indent: { left: 600, right: 600 },
                        children: [
                            new TextRun({
                                text: match[1],
                                size: 24,
                                bold: true
                            }),
                        ],
                    }),
                    new Paragraph({
                        indent: { left: 600, right: 600 },
                        children: [
                            new TextRun({
                                text: match[2],
                                size: 24,
                            }),
                        ],
                    })
                );
            } else {
                combinedContent.push(
                    new Paragraph({
                        indent: { left: 600, right: 600 },
                        children: [
                            new TextRun({
                                text: pocText,
                                size: 24,
                            }),
                        ],
                    })
                )
            }
            if (matchingPocDetails) {
                const pocFiles = matchingPocDetails.data.files || [];
                const currentPocFiles = pocFiles.filter(
                    (file) => file.pocFolder === `poc-${i}`
                );
                if (currentPocFiles.length > 0) {
                    for (let j = 0; j < currentPocFiles.length; j++) {
                        const file = currentPocFiles[j];
                        if (file.url) {
                            try {
                                const pocImageData = await fetchImageAsBase64(file.url);
                                const dimensions = await getImageDimensions(pocImageData);

                                const imageRun = new ImageRun({
                                    data: pocImageData.split(",")[1],
                                    transformation: {
                                        width: dimensions.width,
                                        height: dimensions.height,
                                    },
                                });
                                combinedContent.push(
                                    new Paragraph({
                                        indent: { left: 600, right: 600 },
                                        spacing: { before: 200, after: 300 },
                                        children: [imageRun],
                                    })
                                );
                            } catch (error) {
                                console.error(
                                    `❌ Error fetching image for vulnerability`,
                                );
                            }
                        }
                    }
                } else {
                    console.log(
                        `No files found for vulnerability`
                    );
                }
            }
        }

        function getSeverityAndColor(severity) {

            let color = "";
            if (severity === "Critical") {
                color = "c00000";
            } else if (severity === "High") {
                color = "ff0000";
            } else if (severity === "Medium") {
                color = "ffc000";
            } else if (severity === "Low") {
                color = "ffff00";
            } else {

                color = "00b050";
            }
            return { severity, color };
        }

        const severity = vulnerability.severity;
        const { color } = getSeverityAndColor(severity);

        return [
            new Paragraph({
                heading: HeadingLevel.HEADING_3,
                tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
                indent: { left: 1100 },
                spacing: { before: 250, after: 400 },
                numbering: { reference: "my-crazy-numbering", level: 1 },
                pageBreakBefore: true,
                children: [
                    new TextRun({
                        text: vulnerability.vulnerabilityName,
                        size: 24,
                        color: "0f0f3f",
                        font: "Gill Sans MT",
                        bold: true,
                        italics: false
                    })
                ],
            }),

            new Table({
                width: { size: 10035, type: WidthType.DXA },
                alignment: AlignmentType.CENTER,
                borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                },
                layout: TableLayoutType.FIXED,
                rows: [
                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 80, after: 80 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Vulnerability",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "7ec4fe" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 80, after: 80 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: vulnerability.vulnerabilityName,
                                            font: "Calibri",
                                            size: 22,
                                            color: "1E1B48",
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "bfe2ff" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 80, after: 80 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Description",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "7ec4fe" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [new Paragraph({
                                    spacing: { before: 80, after: 80 },
                                    alignment: AlignmentType.LEFT,
                                    indent: { left: 100 },
                                    children: [new TextRun({
                                        text: vulnerability.description,
                                        font: "Calibri",
                                        size: 22,
                                        color: "1E1B48",
                                        italics: false
                                    })
                                    ]
                                })
                                ],
                                shading: { type: ShadingType.SOLID, color: "bfe2ff" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                        ]
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 80, after: 80 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Affected Source File/Line number",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "7ec4fe" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,

                                children: vulnerability.affectedParameter
                                    .split(/\r?\n/)
                                    .filter(line => line.trim() !== "")
                                    .map(line =>
                                        new Paragraph({
                                            spacing: { before: 80, after: 80 },
                                            alignment: AlignmentType.LEFT,
                                            indent: { left: 100, right: 100 },
                                            children: [
                                                new TextRun({
                                                    text: line.trim(),
                                                    font: "Calibri",
                                                    size: 22,
                                                    color: "1E1B48",
                                                    italics: true
                                                })
                                            ]
                                        })
                                    ),

                                shading: { type: ShadingType.SOLID, color: "bfe2ff" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            })


                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 80, after: 80 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Risk/Impact",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "7ec4fe" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [new Paragraph({
                                    spacing: { before: 80, after: 80 },
                                    alignment: AlignmentType.LEFT,
                                    indent: { left: 100 },
                                    children: [new TextRun({
                                        text: vulnerability.risk,
                                        font: "Calibri",
                                        size: 22,
                                        color: "1E1B48",
                                        italics: false
                                    })
                                    ]
                                })
                                ],
                                shading: { type: ShadingType.SOLID, color: "bfe2ff" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                        ]
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 80, after: 80 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Risk Rating",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "7ec4fe" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [new Paragraph({
                                    spacing: { before: 80, after: 80 },
                                    alignment: AlignmentType.LEFT,
                                    indent: { left: 100 },
                                    children: [new TextRun({
                                        text: `${severity}`,
                                        font: "Calibri",
                                        size: 22,
                                        color: color,
                                        italics: false,
                                        bold: true
                                    })
                                    ]
                                })
                                ],
                                shading: { type: ShadingType.SOLID, color: "bfe2ff" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 80, after: 80 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Recommendation/ Solution",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "7ec4fe" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                spacing: { before: 80, after: 80 },
                                indent: { left: 100 },
                                children: [
                                    new Paragraph({
                                        indent: { left: 100 },
                                        children: [
                                            new TextRun({
                                                text: "ISECURION recommends:",
                                                font: "Calibri",
                                                size: 22,
                                                color: "1E1B48",
                                                italics: false
                                            }),
                                        ]
                                    }),
                                    ...vulnerability.recommendation.split(/•\s*/).filter(Boolean).map(bulletText =>
                                        new Paragraph({
                                            indent: { left: 700, right: 100 },
                                            bullet: { level: 0 },
                                            children: [
                                                new TextRun({
                                                    text: bulletText.trim(),
                                                    font: "Calibri",
                                                    size: 22,
                                                    color: "1E1B48",
                                                    italics: false
                                                })
                                            ]
                                        })
                                    )
                                ],
                                shading: { type: ShadingType.SOLID, color: "bfe2ff" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),


                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 80, after: 80 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Reference",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "7ec4fe" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 30, after: 500 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "https://cwe.mitre.org/data/definitions/200",
                                            font: "Calibri",
                                            size: 22,
                                            color: "1E1B48",
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "bfe2ff" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                        ]
                    }),
                ]
            }),

            new Paragraph({
                pageBreakBefore: true,
                
            }),

            new Paragraph({
                indent: { left: 600 },
                spacing: { before: 200, line: 356 },

                children: [
                    new TextRun({
                        text: "Proof of Concept",
                        size: 24,
                        color: "0f0f3f",
                        font: "Calibri",
                        bold: true,
                        italics: false

                    })
                ],
            }),

            ...combinedContent
        ]
    })
    const docSectionsResolved = await Promise.all(docSections);

    // client Logo
    let clientImageRun;

    if (image) {
        try {
            const clientImageData = await getBase64(image)
            clientImageRun = new ImageRun({
                data: clientImageData,
                transformation: { width: 100, height: 25 }
            })
            console.log("Selected", clientImageRun);
        }
        catch (error) {
            console.error('Error while uploading client image:', error);
        }
    } else if (imageUrl) {
        try {
            const clientImageData = await fetchImageAsBase64(imageUrl);
            clientImageRun = new ImageRun({
                data: clientImageData.split(',')[1],
                transformation: { width: 100, height: 25 }
            });
        } catch (error) {
            console.error('Error while fetching client image from URL:', error);
        }
    }

    const imageData = await fetch(isecurionlogo).then(response => response.blob());
    const footerIsecurion = new ImageRun({
        type: 'png',
        data: await imageData.arrayBuffer(),
        transformation: {
            width: 70,
            height: 18
        },
    });

    const doc = new Document({
        creator: "ISECURION",
        features: { updateFields: true },
        numbering: {
            config: [
                {
                    reference: "my-crazy-numbering",
                    levels: [
                        {
                            level: 0,
                            format: LevelFormat.DECIMAL,
                            text: "4.%1",
                            alignment: AlignmentType.RIGHT,
                            style: {
                                paragraph: {
                                    indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                                },
                                run: {
                                    size: 32,
                                    bold: true,
                                    color: "0f0f3f",
                                    italics: false
                                },
                            },
                        },
                        {
                            level: 1,
                            format: LevelFormat.DECIMAL,
                            text: "5.%2",
                            alignment: AlignmentType.RIGHT,
                            style: {
                                paragraph: {
                                    indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                                },
                                text: { color: "#0f0f3f", bold: true, size: 24 },
                                run: {
                                    size: 24,
                                    bold: true,
                                    color: "0f0f3f",
                                },
                            },
                        },

                    ]
                }
            ]
        },
        styles: {
            default: {

                document: {
                    run: {
                        font: "Calibri",
                        bold: false,
                        size: 22,
                        color: "0f0f3f",
                    },
                },
                heading2: {
                    run: {
                        size: 40,
                        color: "0189f9",
                        font: "Gill Sans MT",
                        bold: true,
                        italics: false,
                        allCaps: false
                    },
                    paragraph: { spacing: { line: 276 } },
                },
                heading3: {
                    run: {
                        font: "Gill Sans MT",
                        size: 24,
                        bold: true,
                        color: "0f0f3f",
                        italics: false
                    },
                    paragraph: { spacing: { line: 276 } },
                },

                paragraph: {
                    run: {
                        italics: false
                    }
                }

            },
            paragraphStyles: [
                {
                    id: "numberedPara",
                    name: "Numbered Para",
                    basedOn: "Normal",
                    next: "Normal",
                    quickFormat: true,
                    run: { font: "Gill Sans MT(Headings)", size: 24, bold: true, },
                    paragraph: {
                        spacing: { line: 276, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
                        rightTabStop: TabStopPosition.MAX,
                        leftTabStop: 453.543307087,
                        numbering: { reference: "my-crazy-numbering", level: 1 },
                    },
                },
            ]
        },
        sections: [
            {
                properties: { page: { margin: { top: 550, right: 0, bottom: -1400, left: 0 }, size: { width: 12240, height: 15840, orientation: PageOrientation.PORTRAIT }, pageNumbers: { start: 0, formatType: NumberFormat.DECIMAL }, } },
                children: [frontPage1, frontPage2, frontPage3, frontPage4],
                pageBreakBefore: true
            },
            //---------------------- page 1 Start----------------------
            {
                properties: {
                    page: {
                        margin: { top: -800, right: 500, bottom: -500, left: 500, header: 500, footer: 500 },
                        size: { width: 12240, height: 15840, orientation: PageOrientation.PORTRAIT },
                        borders: {
                            pageBorderBottom: { style: BorderStyle.DASH_SMALL_GAP, size: 1 * 8, color: "1e8ff9" },
                            pageBorderLeft: { style: BorderStyle.DASH_SMALL_GAP, size: 1 * 8, color: "1e8ff9" },
                            pageBorderRight: { style: BorderStyle.DASH_SMALL_GAP, size: 1 * 8, color: "1e8ff9" },
                            pageBorderTop: { style: BorderStyle.DASH_SMALL_GAP, size: 1 * 8, color: "1e8ff9" },
                            pageBorders: {
                                display: PageBorderDisplay.ALL_PAGES,
                                offsetFrom: PageBorderOffsetFrom.TEXT,
                                zOrder: PageBorderZOrder.FRONT,
                            },
                        },
                        type: SectionType.CONTINUOUS,
                    },
                },
                headers: {
                    default: new Header({
                        children: [
                            new Table({
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" }
                                },
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                children: [
                                                    new Paragraph({
                                                        indent: { left: 200, },
                                                        width: { size: 50, type: WidthType.PERCENTAGE },
                                                        children: [new TextRun({
                                                            text: "Application Source Code Audit Report",
                                                            font: "Calibri",
                                                            size: 24,
                                                            italics: false
                                                        })],
                                                    })],
                                                borders: {
                                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" }
                                                },
                                                margins: { top: 100, bottom: 100, left: 100, right: 100 },
                                            }),
                                            new TableCell({
                                                children: [
                                                    new Paragraph({ indent: { right: 2000 } })],
                                                borders: {
                                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                            new TableCell({
                                                children: [
                                                    new Paragraph({ indent: { right: 400 }, alignment: AlignmentType.RIGHT, children: [clientImageRun] })],
                                                borders: {
                                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                },
                footers: {
                    default: new Footer({
                        children: [
                            new Table({
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                },
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: { size: 18, type: WidthType.PERCENTAGE },
                                                children: [
                                                    new Paragraph({ indent: { left: 200 }, children: [footerIsecurion] })],
                                                borders: {
                                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                            new TableCell({
                                                width: { size: 68, type: WidthType.PERCENTAGE },
                                                children: [
                                                    new Paragraph({
                                                        indent: { right: 200 },
                                                        alignment: AlignmentType.CENTER,
                                                        children: [new TextRun({
                                                            text: "Copyright © 2026 ISECURION",
                                                            font: "Calibri",
                                                            size: 18,
                                                            italics: false
                                                        })]
                                                    })],
                                                borders: {
                                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                            new TableCell({
                                                width: { size: 14, type: WidthType.PERCENTAGE },
                                                children: [
                                                    new Paragraph({
                                                        alignment: AlignmentType.CENTER,
                                                        children: [
                                                            new TextRun({
                                                                children: [PageNumber.CURRENT],
                                                                italics: false,
                                                                font: "Calibri",
                                                                size: 28,
                                                                bold: true
                                                            })
                                                        ]
                                                    })],
                                                borders: {
                                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    })
                },
                children: [page11, page12, page13, page14],
                pageBreakBefore: true
            },
            //---------------------- page 1 End----------------------
            //---------------------- page 2 Start----------------------
            {
                properties: { ...design },
                children: [page21, page22, page23, page24],
                pageBreakBefore: true

            },
            //---------------------- page 2 End----------------------
            //---------------------- page 3 Start----------------------
            {
                properties: { ...design },
                children: [page31, page32, page33, page34, page35, page36, page37],
                pageBreakBefore: true

            },
            //---------------------- page 3 End----------------------
            //---------------------- page 4 Start----------------------
            {
                properties: { ...design },
                children: [page41,
                    new Table({
                        width: { size: 90, type: WidthType.PERCENTAGE },
                        layout: TableLayoutType.FIXED,
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        },
                        alignment: AlignmentType.LEFT,
                        indent: { size: 500, type: WidthType.DXA },
                        rows: [
                            new TableRow({
                                children: [
                                    new TableCell({
                                        width: { size: 90, type: WidthType.PERCENTAGE },
                                        children: [
                                            new Paragraph({
                                                children: [
                                                    new TableOfContents("Table of Content", {
                                                        hyperlink: true,
                                                        headingStyleRange: "1-5",
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
                pageBreakBefore: true
            },
            //---------------------- page 4 End----------------------
            //---------------------- page 5 Start----------------------
            {
                properties: { ...design },
                children: [page51, page52, page53, page54, page55, page56, page57, page58],
                pageBreakBefore: true
            },
            //---------------------- page 5 End----------------------
            //---------------------- page 6 Start----------------------
            {
                properties: { ...design },
                children: [page61, page62, page63, page64],
                pageBreakBefore: true
            },
            //---------------------- page 6 End----------------------
            //---------------------- page 7 Start----------------------
            {
                properties: { ...design },
                children: [page71, page72, page73, page74, page75, page76, page77, page78, page79, page80, page711, page712, page713, page714],
                pageBreakBefore: true
            },
            //---------------------- page 7 End----------------------
            //---------------------- page 8 Start----------------------
            {
                properties: { ...design },
                children: [page81, page82, page83, page84],
                pageBreakBefore: true
            },
            //---------------------- page 8 End----------------------
            //---------------------- page 9 Start----------------------
            {
                properties: { ...design },
                children: [page91, page92, page93, page94, page95, page96, page97, page98, page99, page100, page911, page912, page913, page914, page915, page916],
                pageBreakBefore: true
            },
            //---------------------- page 9 End----------------------
            //---------------------- page 10 Start----------------------
            {
                properties: { ...design },
                children: [page101, page102, page103, page104, page105, page106, page107, page108, page109, page110, page1011, page1012, page1013, page1014, page1015, page1016, page1017,],
                pageBreakBefore: true
            },
            //---------------------- page 10 End----------------------
            //---------------------- page 11 Start----------------------
            {
                properties: { ...design },
                children: [page111, page112, page113, page114, page115, page116, page117, page118, page119],
                pageBreakBefore: true
            },
            //---------------------- page 11 End----------------------
            //---------------------- page 12 Start----------------------
            {
                properties: { ...design },
                children: [page121, page122, page123],
                pageBreakBefore: true
            },
            //---------------------- page 12 End----------------------
            //---------------------- page 13 Start----------------------
            {
                properties: { ...design },
                children: [page131, page132, page133, page134],
                pageBreakBefore: true
            },
            //---------------------- page 13 End----------------------
            //---------------------- page 14 Start----------------------
            {
                properties: { ...design },
                children: [page141, new Table({
                    width: { size: 89, type: WidthType.PERCENTAGE },
                    alignment: AlignmentType.CENTER,
                    spacing: { before: 1200 },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                    },
                    rows: rows
                })],
                pageBreakBefore: true
            },
            //---------------------- page 14 End----------------------
            //---------------------- page 15 Start----------------------
            {
                properties: { ...design },
                children: [page151, page152, page153, page154],
                pageBreakBefore: true
            },
            //---------------------- page 15 End----------------------

            {
                properties: { ...design },
                children: [...docSectionsResolved.flat()],
                pageBreakBefore: true
            },
            {
                properties: { ...design },
                children: [page161]
            }
        ]
    })

    try {
        setLoading(true)
        const response = await fetch(`${url}/reportdownload`, {
            method: 'POST',
            credentials: 'include'
        })
        if (response.status === 200) {
            Packer.toBlob(doc).then(blob => {
                saveAs(blob, `${reportName}.docx`);
            });
            setLoading(false)
            return
        }
        if (response.status !== 200) {
            setLoading(false)
            return
        }
        if (response.status === 440) {
            setLoading(false)
            logout()
            toast.error("User logout due to inactivity", {
                position: 'top-right',
                autoClose: 2500,
                pauseOnHover: false,
            });
            return
        }

    } catch (error) {
        console.log(error)
    }
}